import { render, staticRenderFns } from "./MobileCaseMgmt.vue?vue&type=template&id=d0486ea0&scoped=true&"
import script from "./MobileCaseMgmt.vue?vue&type=script&lang=js&"
export * from "./MobileCaseMgmt.vue?vue&type=script&lang=js&"
import style0 from "./MobileCaseMgmt.vue?vue&type=style&index=0&id=d0486ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0486ea0",
  null
  
)

export default component.exports